module.exports = __webpack_public_path__ + "img/trd.a924a128.svg";